import { createStore } from 'vuex'
// 本地化存储
import createPersistedState from "vuex-persistedstate";
import loginModel from "./login"
import manuAction from "./manuAction"
import dictModel from "./dict" // 数据字典相关
import homeModel from "./home" // 首页相关
import competitionModel from "./competition" // 大赛相关
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loginModel: loginModel,
    manuAction:manuAction,
    dictModel:dictModel,
    homeModel:homeModel,
    competitionModel:competitionModel
  },
  // 设置本地化存储
  plugins: [
    // 默认储存在localstorage
    createPersistedState({
      // 本地储存名
      key: 'xietongptai2024',
      // 指定数据进行本地存储
      paths: ['loginModel.login','loginModel.userInfo','loginModel.auth']
      // paths: ['loginModel.userInfo','loginModel.auth',]
    })
  ],
})
